import {SvgIcon, SvgIconProps} from "@mui/material";

export const AtlassianIcon = (props: SvgIconProps) => <SvgIcon
  xmlns="http://www.w3.org/2000/svg"
  version="1"
  viewBox="0 0 180 180"
  {...props}
>
  <path
    fill="#4169E1"
    d="M580 1422l-315-117 3-214c4-298 25-400 113-548 73-122 257-285 302-267 11 4 157 326 157 347 0 3-16 11-35 17-54 18-122 92-140 152-19 65-19 93 0 149 56 165 256 222 386 110 77-65 107-169 74-260-22-64-52-99-111-132-30-17-54-37-54-45 0-26 133-336 147-341 25-10 58 6 128 62 122 97 210 219 255 355 32 96 39 150 46 391l6 219-33 14c-48 20-606 226-610 226-2-1-146-54-319-118z"
    transform="matrix(.1 0 0 -.1 0 180)"
  ></path>
</SvgIcon>
